/** URL `?tab=` values for material request overview. */
export const MaterialRequestOverviewTabParam = {
  OVERVIEW: "overview",
  LINE_ITEMS: "line-items",
} as const;

export type MaterialRequestOverviewTabParamValue =
  (typeof MaterialRequestOverviewTabParam)[keyof typeof MaterialRequestOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, MaterialRequestOverviewTabParamValue> = {
  "1": MaterialRequestOverviewTabParam.OVERVIEW,
  "2": MaterialRequestOverviewTabParam.LINE_ITEMS,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [MaterialRequestOverviewTabParam.OVERVIEW]: "1",
  [MaterialRequestOverviewTabParam.LINE_ITEMS]: "2",
};

export function materialRequestOverviewTabIdFromSearchParam(
  tab: string | null,
): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForMaterialRequestOverviewTabId(
  tabId: string,
): MaterialRequestOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidMaterialRequestOverviewTabParam(
  tab: string | null,
): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
